var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { createRef } from 'lit/directives/ref.js';
import { styleMap } from 'lit/directives/style-map.js';
import { PIC, PICAction, PICBase, PICLoadPage, PICModal, booleanDecoder, customElement, fetchApiData, loadPage, numberDecoder, openChoiceBox, stringDecoder, stringDecoderLC } from '../Internals';
let PICHatchClerk = class PICHatchClerk extends PICBase {
    constructor() {
        super(...arguments);
        this.bays = new Map();
        this.curBay = '';
        this.curBayLst = '';
        this.curBayArr = [];
        this.curRowLst = '';
        this.curTierLst = '';
        this.bookingData = [];
        this.shiftingData = [];
        this.curSelected = { curCard: undefined, curCell: undefined };
        this.emptyCell = {
            txt: '&nbsp',
            txt1: '&nbsp',
            txt2: '&nbsp',
            txt3: '&nbsp',
            txt4: '&nbsp',
            txt5: '&nbsp',
            txt6: '&nbsp',
            txt7: '&nbsp',
            txt8: '&nbsp',
            txt9: '&nbsp',
            brt: '',
            trb: '',
            cBay: '',
            cRow: '',
            cTier: '',
            cssStr: '',
            usesTEU: 0,
            refNoBay: '',
            actNo: '',
        };
        this.showLegend = false;
        this.selectedLegendKeys = new Set();
        this.bayError = undefined;
        this.baySumError = [];
        this.baySumSymbolMap = [];
        this.baySumColorMap = [];
        this.confirmPlacement = true;
        this.noHdrFooter = true;
        this.lastCellTier = true;
        this.bottomRefreshTimer = 10000;
        this.infoBtn = false;
        this.isInnerNavVisible = false;
    }
    /* Horrible attempt to add missing stylesheets to light dom */
    createCSSNode(link) {
        let linkElm = document.createElement('link');
        linkElm.setAttribute('rel', 'stylesheet');
        linkElm.setAttribute('href', link);
        document.head.appendChild(linkElm);
    }
    appendCSSLinksToHead() {
        let links = [
            '/scripts/fonts/picfonts.css',
            '/scripts/fonts/fontawesome-free-6.1.1-web/css/all.min.css',
        ];
        links.forEach((linkStr) => this.createCSSNode(linkStr));
    }
    connectedCallback() {
        super.connectedCallback();
        this.handleDataRefresh();
        this.nextBayAction = new PICAction();
        this.prevBayAction = new PICAction();
        this.refreshBayAction = new PICAction();
        this.legendRef = createRef();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.handleDataRefresh(true);
    }
    firstUpdated() {
        this.nextBayAction.type_ = 'internal';
        this.nextBayAction.eventFnc = this.getNextBay.bind(this);
        this.prevBayAction.type_ = 'internal';
        this.prevBayAction.eventFnc = this.getPrevBay.bind(this);
        this.refreshBayAction.type_ = 'internal';
        this.refreshBayAction.eventFnc = this.refreshBay.bind(this);
        this.getBay(undefined);
        this.callMode == 'loading' ? this.getBookings() : this.getShiftings();
        this.requestUpdate();
    }
    updated() {
        var _a;
        // For some reason the picselector does not handle its options at the right time
        if (this.baySelector)
            (_a = this.baySelector.optionContainer) === null || _a === void 0 ? void 0 : _a.optHandler();
    }
    static get styles() {
        const defaultStyle = css `
      :host {
        /* Adjustable from progress */
        --bayTableHeaderBGColor: #ffffff;
        --reeferBGColor: mediumslateblue;
        --reeferFwBGColor: var(--reeferBGColor);
        --reeferAsternBGColor: var(--reeferBGColor);
        --noDGSBGColor: var(--picRedColor);
        --fixBGColor: var(--defaultBGColorOrg);
        --emptyBGColor: #ffffd2;
        --placedBGColor: rgb(255, 0, 255);
        --placedEndBGColor: rgb(221, 221, 221);
        --cobBGColor: var(--picYellowColor);
        --selectedBGColor: green;
        --disabledCellBGColor: transparent;

        --pic-buttonActiveColor: var(--pic-primaryColor);
        --pic-buttonActiveBGColor: var(--pic-primaryActiveColor);
        --pic-buttonFocusBGColor: var(--pic-primaryFocusColor);
        --pic-buttonHoverBGColor: var(--pic-primaryHoverColor);
        --pic-buttonOutlinedBorderColor: var(--pic-blackOverlayFocusColor);
        --pic-smallcellsize: clamp(0.75rem, 2vw, 1rem);
      }

      .nav {
        grid-area: nav;
        display: flex;
        flex-direction: row;
        /* height: 100%; */
        background-color: #ffffff;
        transition-property: width;
        transition-duration: 0.5s;
        transition-delay: 0.2s;  
      }

      .navShadow {
        box-shadow: 2px 4px 4px 0px rgba(0, 0, 0, 0.25);
        z-index: 1;
      }

      .top {
        grid-area: top;
        height: 120px;
        display: flex;
        max-height: 3.625rem;
        justify-content: space-between;
      }
      .bay {
        grid-area: bays;
        overflow-y: scroll;
        scrollbar-width: none;
      }
      .bottom {
        grid-area: bottom;
        height: 120px;
        /* margin-top: 0.25rem; */
      }
      .outercontainer {
        display: grid;
        row-gap: 14px;
        height: 100%;
        width: calc(100% - 48px);
        grid:
          'nav top'
          'nav bays'
          'nav bottom';
        grid-template-columns: 48px 1fr;
        grid-template-rows: 58px 1fr 56px;
        position: absolute;
      }
      .gridNoBottom {
        grid:
          'nav top'
          'nav bays'
          ;
        grid-template-columns: 48px 1fr;
        grid-template-rows: 58px 1fr;
      }
      /* #infoBtn, */
      #prevBtn,
      #backBtn,
      #nextBtn,
      #refreshBtn,
      #infoBtn {
        margin-top: 1.375rem;
      }
      .prevBay,
      .nextBay,
      .baySelector {
        color: var(--pic-buttonColor);
        border: 1px solid var(--pic-buttonOutlinedBorderColor);
        border-radius: 0.25rem;
        /* max-height: 2.25rem; */
        padding: 0.625rem 0.875rem;
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10 and IE 11 */
        user-select: none;
      }
      .prevBay:hover,
      .nextBay:hover,
      .baySelector:hover {
        cursor: pointer;
        background-color: var(--pic-buttonHoverBGColor);
        border-radius: 0.25rem;
      }
      .prevBay:focus,
      .nextBay:focus,
      .baySelector:focus {
        background-color: var(--pic-buttonFocusBGColor);
        border-radius: 0.25rem;
        outline: none;
      }
      .prevBay:active,
      .nextBay:active,
      .baySelector:active {
        background-color: var(--pic-buttonActiveBGColor);
        border-radius: 0.25rem;
        color: var(--pic-buttonActiveColor);
        outline: none;
      }
      .legendCloseButton {
        margin-top: 0;
      }
      .baySelectorContainer {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
      }
      .baySelectorContainer label {
        top: 8px;
        position: relative;
        left: 16px;
        background-color: rgb(255, 255, 255);
        width: fit-content;
      }
      .baySelector {
        width: 160px;
        height: 36px;
        background-color: unset;
        padding: 0;
      }
      .baySelector.Option {
        font-size: 0.875rem;
        line-height: 1rem;
        display: unset;
        white-space: unset;
        min-height: unset;
        text-align: center;
        height: var(--pic-densityLowInputHeight);
      }
      .baySelector.Option:hover {
        background-color: var(--pic-primaryHoverColor);
      }
      .baySelector.Option:focus {
        background-color: var(--pic-primaryFocusColor);
      }
      .baySelector.Option:active {
        background-color: var(--pic-primaryActiveColor);
      }

      .bayTable {
        /* height: 100%; */
        border-collapse: collapse;
        table-layout: fixed;
      }
      .bayTable thead {
        background-color: var(--bayTableHeaderBGColor);
      }
      .bayTable td,
      .bayTable th {
        height: 28px;
        border: 1px solid var(--pic-outline);
      }
      .bayTable td {
        border: 1px solid var(--pic-outline);
        height: 46px;
        overflow: hidden;
        width: clamp(110px, 20vw, 100vw);
      }
      .bayTable tr td:first-child {
        width: unset;
      }
      .bayTable .tableHeader td {
        padding: 0 6px;
      }
      .pic-smallcell {
        /* font-size: var(--pic-smallcellsize); */
      }

      .pic-xlargecell {
        /* font-size: x-large; */
        /* text-align: left !important; */
      }

      .pic-reeferfw {
        background-color: var(--reeferFwBGColor);
        transition: background-color 1s;
      }

      .pic-reeferastern {
        background-color: var(--reeferAsternBGColor);
        transition: background-color 1s;
      }

      .pic-nodgs {
        background-color: var(--noDGSBGColor);
        transition: background-color 1s;
      }

      .pic-fix {
        background-color: var(--fixBGColor);
        transition: background-color 1s;
      }

      .pic-empty {
        background-color: var(--emptyBGColor);
        transition: background-color 1s;
      }

      .pic-placed {
        background-color: var(--placedBGColor);
        transition: background-color 1s;
      }

      .pic-placedend {
        background-color: var(--placedEndBGColor);
        transition: background-color 1s;
      }

      .pic-cob {
        background-color: var(--cobBGColor);
        transition: background-color 1s;
      }
      .tableHeader {
        background-color: var(--bayTableHeaderBGColor);
        text-align: center;
      }
      .pic-disabledcell {
        background-color: var(--disabledCellBGColor);
      }
      .deckRowHdrCell {
        width: 2rem;
        background-color: var(--bayTableHeaderBGColor);
      }
      .eqContainer {
        display: inline-flex;
        gap: 0.25rem;
      }
      .eqTimeStamp {
        font-size: 12px;
      }
      .eqList {
        margin: 0;
        padding-inline-start: 0;
        /* font-size: clamp(0.75rem, 2vw, 1rem); */
      }
      .eqList p {
        margin: 0;
      }
      .pic-green {
        background-color: var(--selectedBGColor);
      }
      .pic-innerCell {
        width: 100%;
        max-width: 100%;
        border-collapse: collapse;
        border: 0;
        table-layout: fixed;
      }
      .pic-innerCell td,
      .pic-innerCell th {
        border: 0px;
        height: auto;
        padding: 0px;
        white-space: nowrap;
      }
      .pic-innerCell td.mid,
      .pic-innerCell th.mid {
        text-align: left;
      }
      .pic-innerCell td.mid,
      .pic-innerCell th.mid {
        width: 16%;
      }
      .pic-innerCell td.right,
      .pic-innerCell th.right {
        text-align: right;
      }
      .pic-innerCell svg {
        width: 100%;
      }
      .nav .innerNav {
        width: 48px;
        height: 100%;
        background-color: rgba(245, 247, 249, 0.45);
        display: flex;
        justify-items: center;
        justify-content: center;
        align-items: center;
      }
      .nav .innerNav:hover {
        cursor: pointer;
      }
      .nav .innerNavBody {
        /* width: 235px; */
        height: 100%;
        overflow-y: scroll;
        scrollbar-width: none;
        padding-left: 24px;
      }
      .slimNav {
        width: 48px;
      }
      .fatNav {
        width: 283px;
      }
      .hidden {
        /* width: 1px; */
        display: none;
      }
      .arrowright::after {
        content: '\u{F035F}';
        font-family: 'Material Design Icons';
        font-size: x-large;
        color: var(--pic-onSurfaceMediumColor);
        bottom: 0px;
      }
      .arrowleft::after {
        content: '\u{F035E}';
        font-family: 'Material Design Icons';
        font-size: x-large;
        color: var(--pic-onSurfaceMediumColor);
        bottom: 0px;
      }
      .legendsHdr {
        width: 158px;
        height: 29px;
        color: var(--PIC-On-Surface-High-Emphasis, rgba(0, 0, 0, 0.87));
        padding-top: 22px;
      }
      .legends {
        display:flex;
        flex-direction: column;
        justify-content: center;
        row-gap: 9px;
      }
      .legendItem {
        width: 207px;
        min-height: 48px;
        height: auto;
        border-radius: 4px;
        border: 1px solid var(--PIC-Outline, rgba(0,0,0,.12));
        display: flex;
        flex-direction: row;
        justify-items: center;
        align-items: center;
        column-gap: 11px;
        cursor: pointer;
      }
      
      .legendSymbol {
        border-radius: 100%;
        background-color: grey;
        width: 44px;
        height: 44px;
        flex-shrink: 0;
        flex-grow: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        text-transform: capitalize;
        margin: 3px;
    }

    .legendItem > div:not(.legendSymbol) {
      min-width: 0;
      flex: 1 1 0;
      overflow-wrap: anywhere;
      white-space: normal;
    }

    .legendItemWhiteText {
      color: #ffffff;
      text-shadow: 2px 2px 4px black;
    }

    .legendItemWhiteSymbol {
      border: 1px solid #ffffff;
      background-color: transparent;
      text-shadow: 2px 2px 4px black;
    }
    
    .innerCellOuterContainer {
        display: grid;
        grid-template-columns: 3fr 1fr 2fr;
        grid-template-rows: 1fr 1fr 1fr;
        width: 100%;
        height: 46px;
    }
    
    .innerCell {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .BaySumOuterContainer {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 22px;
        justify-content: center;
        margin-bottom: 22px;
    }

    .tinyBayHdr {
        background-color: var(--pic-primaryColor);
        color: rgba(255, 255, 255, 1);

    }

    .tinyBay {
        border-collapse: collapse;
    }

    .tinyBay td, .tinyBay th {
        font-weight: 400;
        height: unset;
        border-collapse: collapse;
        border: 1px solid var(--pic-outline);
        padding: 0 5px;
    }
    .tinyCell {
        /* transition: background-color 1s; */
        /* background-color: var(--disabledCellBGColor); */
        text-align: center;
      }
    .selected {
        border: 2px dashed black;
    }
    .bayErrorDiv {
      width: 400px;
      height: 250px;
      position: absolute;
      left: calc(50% - 200px);
      top: 30%;
      background-color: var(--pic-backgroundColor);
      border: 1px solid var(--pic-statusErrorColor);
      border-radius: 4px;
      padding: 10px 16px;
      box-shadow: 2px 4px 4px 0px rgba(0, 0, 0, 0.25);
      overflow-y: auto;
    }
    .bayErrorDiv ul{
      list-style-type: '\u{F0028}';
      padding-inline-start: 25px;
    }
    .bayErrorDiv ul li::marker{
      font-family: "Material Design Icons";
      font-size: medium;
      height: 12px;
      width: 12px;
      color: var(--pic-statusErrorColor);
    }
    .errorTxt {
      color: var(--pic-statusErrorColor);
    }
    .errorTxt.pic-body1{
      text-align: center;
    }
    `;
        return css `
      ${super.styles}
      ${defaultStyle}
    `;
    }
    refreshBay() {
        if (this.curBay === 'All') {
            this.bays.clear();
            this.baySumSymbolMap.length = 0;
            this.baySumColorMap.length = 0;
            this.baySumError.length = 0;
            this.getAllBaySumData();
        }
        else {
            if (this.curBayArr[0] == this.curBay) {
                if (this.curBayArr.length > 1) {
                    this.curBay = this.curBayArr[1];
                    this.getBay('prev');
                }
            }
            else {
                this.curBay = this.curBayArr[this.curBayArr.indexOf(this.curBay) - 1];
                this.getBay('next');
            }
            this.callMode == 'loading' ? this.getBookings() : this.getShiftings();
        }
    }
    handleDataRefresh(clearAll) {
        if (clearAll || this.curBay === 'All') {
            clearInterval(this.intervalID);
            this.intervalID = undefined;
        }
        else if (!this.intervalID)
            this.intervalID = setInterval(() => {
                this.refreshBay();
            }, this.bottomRefreshTimer);
    }
    getData(mode, request, selectedBay, selectedData) {
        let tmpData = request ? { selectedBay: selectedBay, request: request } : { selectedBay: selectedBay };
        if (mode === 'ask') {
            tmpData = Object.assign(Object.assign({}, tmpData), selectedData);
        }
        this.options = {
            // sessionId: PIC.getInstance.sessionCode,
            systemId: PIC.getInstance.systemId,
            postBody: {
                sessionId: PIC.getInstance.sessionCode,
                mode: mode,
                data: tmpData,
            },
        };
        return fetchApiData('vessel/vesselplanner', this.options);
    }
    getNextBay() {
        if (this.curBayArr[this.curBayArr.length - 1] == this.curBay) {
            this.curBay = 'All';
            this.requestUpdate();
        }
        else
            this.getBay('next');
    }
    getPrevBay() {
        if (this.curBayArr[0] == this.curBay) {
            this.curBay = 'All';
            this.requestUpdate();
        }
        else
            this.getBay('prev');
    }
    getBay(iReq) {
        this.bayError = undefined;
        this.getData('getBay', iReq, this.curBay)
            .then((bay) => {
            if (Object.keys(bay).includes('errType')) {
                let errObj = {
                    errType: bay.errType,
                    errMsg: bay.errMsg
                };
                let bayId = '';
                if (Object.keys(bay).includes('bayId'))
                    bayId = bay.bayId;
                else if (!iReq && this.curBay && this.curBay !== 'All')
                    bayId = this.curBay;
                else if (iReq === 'next') {
                    if (this.curBay === 'All')
                        bayId = this.curBayArr[0];
                    else
                        bayId = this.curBayArr[this.curBayArr.indexOf(this.curBay) + 1];
                }
                else if (iReq === 'prev') {
                    if (this.curBay === 'All')
                        bayId = this.curBayArr[this.curBayArr.length - 1];
                    else
                        bayId = this.curBayArr[this.curBayArr.indexOf(this.curBay) + 1];
                }
                if (bayId)
                    errObj.bayId = bayId;
                this.bayError = errObj;
            }
            else {
                this.bay = bay[0];
                if (this.bay) {
                    this.curBay = this.bay.id;
                    this.curBayLst = this.bay.bayLst;
                    this.curBayArr = this.bay.bayLst.split(',');
                    this.curRowLst = this.bay.rowLst;
                    this.curTierLst = this.bay.tierLst;
                    this.updateColorVars(this.bay.colors);
                }
            }
            this.requestUpdate();
        })
            .catch((err) => PIC.getInstance.msg(err));
    }
    getBays() {
        this.getData('getBays', undefined, undefined)
            .then((bays) => {
            bays.forEach(bay => this.bays.set(bay.id, bay));
            PIC.getInstance.msg(this.bays);
            this.requestUpdate();
        })
            .catch((err) => PIC.getInstance.msg(err));
    }
    getShiftings() {
        this.getData('getShiftings', undefined, undefined)
            .then((shiftingData) => {
            this.shiftingData = shiftingData.ttShift ? shiftingData.ttShift : [];
            this.lastUpdatedEQ = new Date();
            this.requestUpdate();
        })
            .catch((err) => PIC.getInstance.msg(err));
    }
    getBookings() {
        this.getData('getBookings', undefined, undefined)
            .then((bookingData) => {
            this.bookingData = bookingData.ttEquip ? bookingData.ttEquip : [];
            this.lastUpdatedEQ = new Date();
            this.requestUpdate();
        })
            .catch((err) => PIC.getInstance.msg(err));
    }
    updateColorVars(iColorVars) {
        if (iColorVars) {
            iColorVars = Array.isArray(iColorVars) ? iColorVars[0] : iColorVars;
            iColorVars.bayTableHeaderBGColor ? this.style.setProperty('--bayTableHeaderBGColor', iColorVars.bayTableHeaderBGColor) : '';
            iColorVars.reeferBGColor ? this.style.setProperty('--reeferBGColor', iColorVars.reeferBGColor) : '';
            iColorVars.reeferFwBGColor ? this.style.setProperty('--reeferFwBGColor', iColorVars.reeferFwBGColor) : '';
            iColorVars.reeferAsternBGColor ? this.style.setProperty('--reeferAsternBGColor', iColorVars.reeferAsternBGColor) : '';
            iColorVars.noDGSBGColor ? this.style.setProperty('--noDGSBGColor', iColorVars.noDGSBGColor) : '';
            iColorVars.fixBGColor ? this.style.setProperty('--fixBGColor', iColorVars.fixBGColor) : '';
            iColorVars.emptyBGColor ? this.style.setProperty('--emptyBGColor', iColorVars.emptyBGColor) : '';
            iColorVars.placedBGColor ? this.style.setProperty('--placedBGColor', iColorVars.placedBGColor) : '';
            iColorVars.placedEndBGColor ? this.style.setProperty('--placedEndBGColor', iColorVars.placedEndBGColor) : '';
            iColorVars.cobBGColor ? this.style.setProperty('--cobBGColor', iColorVars.cobBGColor) : '';
            iColorVars.selectedBGColor ? this.style.setProperty('--selectedBGColor', iColorVars.selectedBGColor) : '';
            iColorVars.disabledCellBGColor ? this.style.setProperty('--disabledCellBGColor', iColorVars.disabledCellBGColor) : '';
        }
    }
    createHiddenFormField(dataName, dataValue) {
        let secretInputFld = document.getElementById('hiddenLuge');
        if (!secretInputFld) {
            secretInputFld = document.createElement('input');
            secretInputFld.setAttribute('type', 'hidden');
            secretInputFld.setAttribute('id', 'hiddenLuge');
        }
        secretInputFld.setAttribute('name', dataName);
        secretInputFld.setAttribute('value', dataValue);
        document.PICForm.appendChild(secretInputFld);
    }
    isSelectable(selectableElmLst) {
        return selectableElmLst && selectableElmLst.length > 0;
    }
    getCOB(e) {
        let selectableElmLst = e
            .composedPath()
            .filter((thing) => thing instanceof HTMLElement &&
            thing.classList.contains('pic-cob') &&
            !thing.classList.contains('pic-disabledcell'));
        if (this.isSelectable(selectableElmLst))
            return selectableElmLst[0];
        else
            return undefined;
    }
    getSelectable(e) {
        let selectableElmLst = e
            .composedPath()
            .filter((thing) => thing instanceof HTMLElement &&
            thing.classList.contains('pic-selectable'));
        if (this.isSelectable(selectableElmLst))
            return selectableElmLst[0];
        else
            return undefined;
    }
    getSelectedCell(selectedElement) {
        if (selectedElement instanceof HTMLTableCellElement)
            return selectedElement;
        else
            return undefined;
    }
    getSelectedCard(selectedElement) {
        if (this.getSelectedCell(selectedElement))
            return undefined;
        else
            return selectedElement;
    }
    isUndoable(undoableElmLst) {
        return undoableElmLst && undoableElmLst.length > 0;
    }
    getUndoable(e) {
        let undoableElmLst = e
            .composedPath()
            .filter((thing) => thing instanceof HTMLElement &&
            thing.classList.contains('pic-placed') &&
            !thing.classList.contains('pic-disabledcell'));
        if (this.isUndoable(undoableElmLst))
            return undoableElmLst[0];
        else
            return undefined;
    }
    getBaySumOuterContainer(e) {
        let t = e.composedPath().filter((elm) => { var _a; return (_a = elm === null || elm === void 0 ? void 0 : elm.classList) === null || _a === void 0 ? void 0 : _a.contains('BaySumOuterContainer'); });
        return t && t.length > 0;
    }
    askBackend(dataToSend, htmlElm) {
        console.log('asking backend');
        this.getData('ask', undefined, this.selectedBay, dataToSend).then((resp) => {
            var _a, _b;
            this.previousSelectedElement = { dataToSend: dataToSend, htmlElm: htmlElm };
            //TODO: backend will send back what to do, this will probably be
            console.log('got answer', resp);
            switch (resp.cmd) {
                // select something and remember its selected
                case 'select':
                    if (htmlElm)
                        htmlElm.classList.toggle('pic-green');
                    break;
                case 'de-select':
                    // de-select something
                    if (htmlElm)
                        htmlElm.classList.toggle('pic-green');
                    break;
                case 'loadpage':
                    // open a loadpage with the selected data and params
                    let options = {};
                    if (htmlElm) {
                        let rNode = htmlElm.getRootNode();
                        if (rNode instanceof ShadowRoot && rNode.host instanceof PICLoadPage) {
                            options['parentSessId'] = (_a = rNode.host) === null || _a === void 0 ? void 0 : _a.selfSessId;
                        }
                        else if (rNode instanceof PICModal && rNode.parent instanceof PICLoadPage) {
                            options['parentSessId'] = (_b = rNode.parent) === null || _b === void 0 ? void 0 : _b.selfSessId;
                        }
                    }
                    loadPage(resp.data.APIUrl, resp.data.Params, options);
                    break;
                case 'refresh':
                    // refresh data
                    this.getData('getBay', undefined, this.selectedBay);
                    break;
                case 'nothing':
                case undefined:
                default:
                    // do nothing
                    break;
            }
        });
    }
    handleSelect(e) {
        var _a, _b, _c, _d;
        //Do not select inside baysum
        if (this.getBaySumOuterContainer(e))
            return;
        this.handleInnerNavClick(e);
        let curCard;
        let curCell;
        let curSelected;
        let curNotDisabled;
        let curCOBCell;
        let curUndoCell;
        let choiceBoxTitle;
        let dataValue;
        curNotDisabled = this.getCOB(e);
        curCOBCell = this.getSelectedCell(curNotDisabled);
        curSelected = this.getSelectable(e);
        curCell = this.getSelectedCell(curSelected);
        curCard = this.getSelectedCard(curSelected);
        curUndoCell = this.getUndoable(e);
        let tmpType = [curCell, curCard, curUndoCell, curCOBCell, curSelected].findIndex(x => x);
        let type = 'empty';
        let dataToSend = { curSelected: {}, prevSelected: (_a = this.previousSelectedElement) === null || _a === void 0 ? void 0 : _a.dataToSend };
        if (tmpType) {
            type = ['cell', 'card', 'placed', 'COB', 'selectable'][tmpType];
            let data = (_d = (_c = (_b = curCell !== null && curCell !== void 0 ? curCell : curCard) !== null && _b !== void 0 ? _b : curUndoCell) !== null && _c !== void 0 ? _c : curCOBCell) !== null && _d !== void 0 ? _d : curSelected;
            if (data) {
                let ser = new XMLSerializer();
                //Any obj
                dataToSend.curSelected = Object.assign(Object.assign({ type: type }, data === null || data === void 0 ? void 0 : data.dataset), { rawData: btoa(ser.serializeToString(data)) });
                this.askBackend(dataToSend, data);
            }
            else {
                //cell with no data - should not be clickable, like unplaceble elements i.e. headers and stuff
            }
        }
        else {
            //Empty cell with no data
            dataToSend.curSelected = { type: type };
            this.askBackend(dataToSend);
        }
    }
    getStyleTinyCell(cell) {
        if (cell)
            return {
                'background-color': '#' + cell.cellColor,
                'transition': 'background-color 1s',
            };
        else
            return {};
    }
    /** Canonical key for a legend row; must match handleLegendClick / renderLegendItem. */
    getLegendRowKey(iTxt, iSymbol, iColor) {
        return iColor ? iTxt : (iSymbol !== null && iSymbol !== void 0 ? iSymbol : iTxt);
    }
    cellMatchesAllLegendKeys(cell) {
        var _a;
        if (this.selectedLegendKeys.size === 0)
            return true;
        const filters = (_a = cell.filterList) === null || _a === void 0 ? void 0 : _a.split(',');
        for (const key of this.selectedLegendKeys) {
            const found = key === cell.txt5 ||
                key === cell.txt8 ||
                key === cell.txt9 ||
                Boolean(filters === null || filters === void 0 ? void 0 : filters.includes(key));
            if (!found)
                return false;
        }
        return true;
    }
    renderTinyBayCell(cell, bay) {
        var _a, _b, _c, _d;
        let cellTxt = '';
        let keepColors = true;
        let destSymbol = '';
        if (typeof cell === 'object') {
            if (bay) {
                destSymbol = (_b = (_a = bay.symbolMap.find((s) => s.dest === cell.txt9)) === null || _a === void 0 ? void 0 : _a.symbol) !== null && _b !== void 0 ? _b : '';
            }
            let filters = (_c = cell.filterList) === null || _c === void 0 ? void 0 : _c.split(',');
            if (cell && cell.txt5)
                cellTxt = (((_d = cell === null || cell === void 0 ? void 0 : cell.txt5) === null || _d === void 0 ? void 0 : _d.startsWith('&')) ? '' : cell === null || cell === void 0 ? void 0 : cell.txt5).slice(0, 1);
            let c = filters === null || filters === void 0 ? void 0 : filters.find((f) => f.toUpperCase() === 'C');
            if (filters === null || filters === void 0 ? void 0 : filters.includes('<'))
                cellTxt = '<';
            else if (c)
                cellTxt = c;
            else if (cell.txt9 && destSymbol)
                cellTxt = destSymbol;
            if (this.selectedLegendKeys.size > 0)
                keepColors = this.cellMatchesAllLegendKeys(cell);
            return html `<td style=${styleMap(this.getStyleTinyCell(keepColors ? cell : undefined))} class="pic-caption tinyCell ${this.getCellCssStr(keepColors, cell)}">${cellTxt}</td>`;
        }
        else
            return html `<td class="pic-caption tinyCell">${cell !== null && cell !== void 0 ? cell : ''}</td>`;
    }
    renderTinyBay(bayId) {
        var _a, _b;
        let rowLst = (_a = this.bay) === null || _a === void 0 ? void 0 : _a.rowLst.split(',');
        let tierLst = (_b = this.bay) === null || _b === void 0 ? void 0 : _b.tierLst.split(',');
        let bay = this.bays.get(bayId);
        return html `
        <table class="tinyBay" id="bay-${bayId}">
            <thead>
                <tr class="tinyBayHdr pic-caption"><th colspan=${rowLst.length + 1}>${bayId}</th></tr>
                <tr><th></th>${rowLst.map(r => html `<th class="pic-caption">${r}</th>`)}</tr>
            </thead>
            <tbody>
                ${tierLst.map(t => html `<tr>${this.renderTinyBayCell(t)}${rowLst.map(r => this.renderTinyBayCell(bay === null || bay === void 0 ? void 0 : bay.cells.find(c => c.cRow == r && c.cTier == t), bay))}</tr>`)}
            </tbody>    
        </table>
    `;
    }
    getBaySumBay(bayId) {
        let options = {
            errorReturn: true,
            // formatOutput: 'json',
            postBody: {
                sessionId: PIC.getInstance.sessionCode,
                mode: 'getBay',
                data: { selectedBay: bayId }
            }
        };
        return fetchApiData('vessel/vesselplanner', options);
    }
    addBaySumBay(bays) {
        let bay = bays[0];
        this.bays.set(bay.id, bay);
        if (bay.symbolMap.length > 0) {
            bay.symbolMap.forEach(sym => {
                if (!this.baySumSymbolMap.find((s) => s.symbol == sym.symbol))
                    this.baySumSymbolMap.push(sym);
            });
        }
        if (bay.colorMap.length > 0) {
            bay.colorMap.forEach(cm => {
                if (!this.baySumColorMap.find((c) => c.dest == cm.dest))
                    this.baySumColorMap.push(cm);
            });
        }
        this.requestUpdate();
    }
    wait(delay) {
        return new Promise(p => setTimeout(p, delay));
    }
    //This will retry number set default, no matter what the catched error might be, i.e. also none network related stuff, every 2000ms
    async baySumBayWrap(bay, noRetries = 5) {
        return this.getBaySumBay(bay)
            .then(bays => {
            if (Object.keys(bays).includes('errType')) {
                let errObj = {
                    errType: bays.errType,
                    errMsg: bays.errMsg,
                    bayId: bay
                };
                this.baySumError.push(errObj);
            }
            else
                this.addBaySumBay(bays);
        })
            .catch(err => {
            //Do retry after delay
            if (noRetries > 0) {
                this.wait(2000).then(() => this.baySumBayWrap(bay, noRetries - 1));
            }
            else {
                console.log('fetch error:', err);
            }
        });
    }
    //This can be set for sequential, or max available, or wait for batchsize to finish
    async getAllBaySumData(doSequential, batchSize) {
        this.baySumError = [];
        let promiseKeeper = [];
        if (doSequential) {
            for (let bay of this.curBayArr) {
                await this.baySumBayWrap(bay);
            }
        }
        else {
            for (let i = 0; i < this.curBayArr.length; i++) {
                let bay = this.curBayArr[i];
                if (batchSize) {
                    if (i % batchSize == 0 || i == this.curBayArr.length - 1) {
                        await Promise.allSettled(promiseKeeper);
                        promiseKeeper = [];
                        promiseKeeper.push(this.baySumBayWrap(bay));
                    }
                    else {
                        promiseKeeper.push(this.baySumBayWrap(bay));
                    }
                }
                else {
                    this.baySumBayWrap(bay);
                }
            }
        }
    }
    renderBaySum() {
        var _a;
        //Run once, else infinite requests
        if (this.bays.size == 0)
            this.getAllBaySumData();
        return html `
        <div class="BaySumOuterContainer">
          ${this.baySumError.length > 0 ? this.renderError(true) : ''}
          ${(_a = this.curBayLst.split(',')) === null || _a === void 0 ? void 0 : _a.map((b) => { return this.renderTinyBay(b); })}
        </div>
    `;
    }
    handleSelectBay(e) {
        // the gigantic shitshow that is the flow of inputoptions -> picmenu handling made this possible
        setTimeout(() => {
            this.curBay = this.baySelector.submitValue;
            if (this.curBay === 'All') {
                this.requestUpdate();
            }
            else
                this.getBay(undefined);
        }, 10);
    }
    renderSelectOption() {
        //Added all for baysum selector
        let optLst = ['All'];
        this.curBayArr.forEach(element => { optLst.push(element); });
        // the gigantic shitshow that is the flow of inputoptions -> picmenu handling made this possible
        return html `${optLst === null || optLst === void 0 ? void 0 : optLst.map((bay) => {
            return html `<data key=${bay} val=${bay} action=${`{"type": "internal", "eventFnc": { "elementId": "${this.id_}", "elementFunction": "handleSelectBay"}}`}></data>`;
        })}`;
    }
    doChoiceBox(iTitle, positiveVentStr) {
        let choiceBoxSelector = 'pic-choicebox[choicebox-x]';
        let choiceBoxData = {
            choiceTitle: iTitle,
            choices: [
                { choiceText: 'Confirm', choiceEvent: positiveVentStr },
                { choiceText: 'Cancel', choiceEvent: '' },
            ],
            attributes: { hidden_: false },
        };
        openChoiceBox(choiceBoxSelector, choiceBoxData);
    }
    getClassInnerNav() {
        return {
            'innerNav': true,
            'arrowright': !this.isInnerNavVisible,
            'arrowleft': this.isInnerNavVisible,
        };
    }
    getClassInnerNavBody() {
        return {
            'innerNavBody': true,
            'hidden': !this.isInnerNavVisible
        };
    }
    handleInnerNavClick(e) {
        let t = e.composedPath().filter((elm) => { var _a; return (_a = elm === null || elm === void 0 ? void 0 : elm.classList) === null || _a === void 0 ? void 0 : _a.contains('nav'); });
        if (t && t.length > 0) {
            this.isInnerNavVisible = true;
            if (e.composedPath().find((elm) => { var _a; return (_a = elm === null || elm === void 0 ? void 0 : elm.classList) === null || _a === void 0 ? void 0 : _a.contains('arrowleft'); }))
                this.isInnerNavVisible = false;
        }
        else
            this.isInnerNavVisible = false;
        this.requestUpdate();
    }
    renderNav() {
        return html `
      <div class=${classMap(this.getClassInnerNavBody())}>
        ${this.renderLegend()}
      </div>
      <div class=${classMap(this.getClassInnerNav())} 
      >
    </div>
    `;
    }
    getSyleLegendItem(iColor) {
        let styles = [];
        if (iColor) {
            styles.push({ 'background-color': '#' + iColor });
        }
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getClassLegendItem(isTxt, iColor) {
        return {
            'pic-caption': true,
            'legendSymbol': !isTxt,
            'legendItemWhiteText': (iColor ? true : false) && isTxt,
            'legendItemWhiteSymbol': (iColor ? true : false) && !isTxt,
        };
    }
    handleLegendClick(e, iTxt, iSymbol, iColor) {
        e.stopImmediatePropagation();
        const key = this.getLegendRowKey(iTxt, iSymbol, iColor);
        const next = new Set(this.selectedLegendKeys);
        if (next.has(key))
            next.delete(key);
        else
            next.add(key);
        this.selectedLegendKeys = next;
        this.requestUpdate();
    }
    renderLegendItem(iTxt, iSymbol, iColor) {
        const isSelected = this.selectedLegendKeys.has(this.getLegendRowKey(iTxt, iSymbol, iColor));
        return html `
        <div class='legendItem${isSelected ? ' selected' : ''}' 
             style=${styleMap(this.getSyleLegendItem(iColor))} 
             @click=${(e) => this.handleLegendClick(e, iTxt, iSymbol, iColor)}
             >
                <div class=${classMap(this.getClassLegendItem(false, iColor))}>${iSymbol ? iSymbol : iTxt.slice(0, 1)}</div>
                <div class=${classMap(this.getClassLegendItem(true, iColor))}>${iTxt}</div>
        </div>`;
    }
    renderLegend() {
        var _a;
        return html `
    <pic-button
      .id=${'backBtn'}
      .label=${'exit'}
      density=${'medium'}
      .width=${'207'}
      etype=${'outlined'}
      .eventId_=${'back'}>
    </pic-button>
    ${this.infoBtn ? html `
        <pic-button
          .id=${'infoBtn'}
          .label=${'info'}
          density=${'medium'}
          .width=${'207'}
          etype=${'outlined'}
          .eventId_=${'infoBtn'}>
        </pic-button>` : ''}
    <div class='legendsHdr pic-body1'>Legend</div>
    <div class='legends'>
        ${this.curBay != 'All' ?
            (_a = this.bay) === null || _a === void 0 ? void 0 : _a.symbolMap.map(sym => { var _a, _b; return this.renderLegendItem(sym.dest, sym.symbol, (_b = (_a = this.bay.colorMap) === null || _a === void 0 ? void 0 : _a.find((cm) => cm.dest == sym.dest)) === null || _b === void 0 ? void 0 : _b.colorHex); }) :
            this.baySumSymbolMap.map(sym => { var _a, _b; return this.renderLegendItem(sym.dest, sym.symbol, (_b = (_a = this.baySumColorMap) === null || _a === void 0 ? void 0 : _a.find((cm) => cm.dest == sym.dest)) === null || _b === void 0 ? void 0 : _b.colorHex); })}
    </div>
      `;
    }
    renderTop() {
        var _a;
        return html `
      <pic-button
      .id=${'prevBtn'}
      .label=${'prev'}
      density=${'medium'}
      etype=${'outlined'}
      .action=${this.prevBayAction}>
      </pic-button>
      <pic-selector 
      .id=${'selectCallMode'} 
      .label=${'Select mode'} 
      .width=${'207'} 
      density=${'medium'} 
      etype=${'default'} 
      .selecttype_=${'spinner'} 
      .value=${this.callMode}
      .changeEvent=${'selectCallMode'}>
        <pic-optiongroup id="__DEFAUT__" minchars="0">
          <data key="loading" val="loading"></data>
          <data key="discharge" val="discharge"></data>
        </pic-optiongroup>
      </pic-selector>
      <pic-selector 
        .id=${'baySelector'} 
        .label=${'Select Bay'} 
        .width=${'207'} 
        density=${'medium'} 
        etype=${'default'} 
        .selecttype_=${'spinner'} 
        .value=${(_a = this.curBay) !== null && _a !== void 0 ? _a : ''}>
          <pic-optiongroup id="__DEFAUT__" minchars="0">
              ${this.renderSelectOption()}
          </pic-optiongroup>
      </pic-selector>
      <pic-button
      .id=${'refreshBtn'}
      .label=${'refresh'}
      density=${'medium'}
      .width=${'120'}
      etype=${'outlined'}
      .action=${this.refreshBayAction}>
      </pic-button>
      <pic-button
      .id=${'nextBtn'}
      .label=${'next'}
      density=${'medium'}
      etype=${'outlined'}
      .action=${this.nextBayAction}>
      </pic-button>
    `;
    }
    renderQuayCard() {
        return html `
    <pic-card
        data-shiftid=${'quay'}
        data-type="shifting"
        class="pic-selectable"
        .dashedBorder=${true}
        .isFile=${false}
        .title_=${'TO QUAY'}
        .drawMode=${'picHatchClerk'}
        ><div class="eqList pic-caption">
        </div>
    </pic-card>
    
    `;
    }
    renderShifting() {
        return html `
      <div class="eqTimeStamp pic-caption">
        Shiftings List Last updated ${this.lastUpdatedEQ}
      </div>
      <div class="eqContainer">
        ${this.renderQuayCard()}
        ${this.shiftingData.map((shift) => html `<pic-card
            data-shiftactno=${shift.actNo}
            data-shiftid=${shift.eqID}
            data-type="shifting"
            class="pic-selectable"
            .isFile=${false}
            .title_=${shift.eqID}
            .drawMode=${'picHatchClerk'}
            ><div class="eqList pic-caption">
              ${shift.actNo ? html `<p>${shift.actNo}</p>` : ``}
              ${shift.eqID ? html `<p>${shift.eqID}</p>` : ``}
              ${shift.eqClass ? html `<p>${shift.eqClass}</p>` : ``}
              ${shift.eqClassSub ? html `<p>${shift.eqClassSub}</p>` : ``}
              ${shift.fromPos ? html `<p>${shift.fromPos}</p>` : ``}
              ${shift.toPos ? html `<p>${shift.toPos}</p>` : ``}
              ${shift.status_ ? html `<p>${shift.status_}</p>` : ``}
              ${shift.gwTxt ? html `<p>${shift.gwTxt}</p>` : ``}
            </div>
          </pic-card>`)}
      </div>
    `;
    }
    renderEquipment() {
        return html `
      <div class="eqTimeStamp pic-caption">
        Equipment List Last updated ${this.lastUpdatedEQ}
      </div>
      <div class="eqContainer">
        ${this.renderQuayCard()}
        ${this.bookingData.map((eq) => html `<pic-card
            data-depbookid=${eq.depBookId}
            data-type="equipment"
            class="pic-selectable"
            .isFile=${false}
            .title_=${eq.eqID ? eq.eqID : eq.depBookId}
            .drawMode=${'picHatchClerk'}
            ><div class="eqList pic-caption">
              ${eq.depBookId ? html `<p>${eq.depBookId}</p>` : ``}
              ${eq.dgsLst ? html `<p>${eq.dgsLst}</p>` : ``}
              ${eq.eqClass ? html `<p>${eq.eqClass}</p>` : ``}
              ${eq.eqPlannedBRT ? html `<p>${eq.eqPlannedBRT}</p>` : ``}
              ${eq.grossWeight ? html `<p>${eq.grossWeight}</p>` : ``}
              ${eq.gwTxt ? html `<p>${eq.gwTxt}</p>` : ``}
              ${eq.isDepOk ? html `<p>${eq.isDepOk}</p>` : ``}
              ${eq.status_ ? html `<p>${eq.status_}</p>` : ``}
              ${eq.nettoWeight ? html `<p>${eq.nettoWeight}</p>` : ``}
              ${eq.sortNo ? html `<p>${eq.sortNo}</p>` : ``}
              ${eq.taraWeight ? html `<p>${eq.taraWeight}</p>` : ``}
            </div>
          </pic-card>`)}
      </div>
    `;
    }
    renderHdrCell(r, idx, rowLst) {
        return html `
      ${idx == 0 ? html `<th class="pic-disabledcell deckRowHdrCell"></th>` : ''}
      <th class="pic-caption">${r}</th>
    `;
    }
    renderHdr(rowLst) {
        if (rowLst)
            return html `<thead class="tableHeader">
        <tr>
          ${rowLst.map((row, idx) => this.renderHdrCell(row, idx, rowLst))}
        </tr>
      </thead>`;
        else
            return html ``;
    }
    getStyleInnerCell(idx) {
        let col = 1;
        let row = 1;
        if (idx === 0 || idx === 3 || idx === 6) {
            col = 1;
        }
        else if (idx === 1 || idx === 4 || idx === 7) {
            col = 2;
        }
        else if (idx === 2 || idx === 5 || idx === 8) {
            col = 3;
        }
        if (idx >= 0 && idx <= 2) {
            row = 1;
        }
        else if (idx >= 3 && idx <= 5) {
            row = 2;
        }
        else if (idx >= 6 && idx <= 8) {
            row = 3;
        }
        return {
            'grid-column': col,
            'grid-row': row
        };
    }
    renderInnerCell(iStr, idx) {
        let tmpStr = iStr == '&nbsp' || iStr == undefined ? html `&nbsp` : iStr;
        return html `<div class="innerCell" style=${styleMap(this.getStyleInnerCell(idx))}>${tmpStr}</div>`;
    }
    renderInnerFlex(cell) {
        let data = [cell.txt1, cell.txt2, cell.txt3, cell.txt4, cell.txt5, cell.txt6, cell.txt7, cell.txt8, cell.txt9];
        return html ` 
        <div class="innerCellOuterContainer">
            ${data.map((d, idx) => this.renderInnerCell(d, idx))}
        </div>
    `;
    }
    getStyleBodyCell(cell) {
        return this.getStyleTinyCell(cell);
    }
    getCellCssStr(keepColors, cell) {
        let cssStr = cell === null || cell === void 0 ? void 0 : cell.cssStr;
        if (!keepColors) {
            cssStr = '';
            //Makes selectable
            if (cell.cssStr.includes('pic-selectable'))
                cssStr += 'pic-selectable';
            //Colors the empty cells
            if (cell.cssStr.includes('pic-empty'))
                cssStr += ' pic-empty';
        }
        return cssStr;
    }
    renderBodyCell(rowIdx, tier, rowLst, cell) {
        var _a, _b;
        let keepColors = true;
        let deckCell = rowIdx == 0 ? html `<td class="tableHeader deckCell pic-caption">${tier}</td>` : '';
        if (cell) {
            let filters = (_a = cell.filterList) === null || _a === void 0 ? void 0 : _a.split(',');
            if (this.selectedLegendKeys.size > 0)
                keepColors = this.cellMatchesAllLegendKeys(cell);
            return html `${deckCell}
        <td
        data-eqid=${(_b = cell.eqId) !== null && _b !== void 0 ? _b : ''}
        data-actno=${cell.actNo}
        data-position=${cell.brt}
        data-symbol=${ifDefined(cell.symbol)}
        style=${ifDefined(styleMap(this.getStyleBodyCell(keepColors ? cell : undefined)))} class="${this.getCellCssStr(keepColors, cell)} pic-caption">
          ${this.renderInnerFlex(cell)}
        </td> `;
        }
        else {
            return html `${deckCell}
        <td class="pic-disabledcell pic-nohover">
            ${this.renderInnerFlex(this.emptyCell)}
        </td> `;
        }
    }
    renderBodyRow(tier, rowLst, cells) {
        return html `<tr>
      ${rowLst.map((row, rowIdx) => this.renderBodyCell(rowIdx, tier, rowLst, cells.find((c) => {
            return c.cRow == row && c.cTier == tier;
        })))}
    </tr>`;
    }
    renderBody(tierLst, rowLst, cells) {
        if (tierLst && rowLst)
            return html `<tbody>
        ${tierLst.map((tier) => this.renderBodyRow(tier, rowLst, cells))}
      </tbody>`;
        else
            return html ``;
    }
    renderBay() {
        var _a, _b, _c;
        let cells = (_a = this.bay) === null || _a === void 0 ? void 0 : _a.cells;
        let tierLst = (_b = this.bay) === null || _b === void 0 ? void 0 : _b.tierLst.split(',');
        let rowLst = (_c = this.bay) === null || _c === void 0 ? void 0 : _c.rowLst.split(',');
        return html `
      ${this.bayError ? this.renderError() : ''}
      <table class="bayTable">
        ${this.renderHdr(rowLst)} ${this.renderBody(tierLst, rowLst, cells)}
      </table>
    `;
    }
    renderError(isBaySum) {
        var _a, _b, _c;
        return html `
    <div class="bayErrorDiv">
      <p class="errorTxt pic-body1">Error</p>
      <ul>
      ${isBaySum ?
            this.baySumError.map((errObj) => { return html `<li class="errorTxt pic-body2">Bay ${errObj.bayId}: ${errObj.errType}. ${errObj.errMsg}</li>`; }) :
            html `<li class="errorTxt pic-body2">${((_a = this.bayError) === null || _a === void 0 ? void 0 : _a.bayId) ? 'Bay ' + this.bayError.bayId + ':' : ''} ${(_b = this.bayError) === null || _b === void 0 ? void 0 : _b.errType}. ${(_c = this.bayError) === null || _c === void 0 ? void 0 : _c.errMsg}</li>`}
      </ul>
    </div>
    `;
    }
    fixParentCSS() {
        let mb = document.querySelector('.pic-mainbody');
        let hdr = document.querySelector('.pic-header');
        if (hdr && mb) {
            hdr.style.display = 'none';
            // mb.style.overflowY = 'hidden';
            Object.assign(mb.style, {
                'height': '100%',
                'min-height': '100%',
                'max-height': '100%',
                'padding': '0',
                'overflow-y': 'scroll',
                'scrollbar-width': 'none',
                'max-width': 'calc(100vw - 24px)',
            });
        }
    }
    getClassNav() {
        return {
            'nav': true,
            'navShadow': this.isInnerNavVisible,
            // 'slimNav': true,
            'slimNav': !this.isInnerNavVisible,
            'fatNav': this.isInnerNavVisible,
        };
    }
    getClassBottom() {
        return {
            'bottom': true,
            'hidden': this.curBay === 'All'
        };
    }
    getClassOuterContainer() {
        return {
            outercontainer: true,
            gridNoBottom: this.curBay === 'All'
        };
    }
    render() {
        this.fixParentCSS();
        this.handleDataRefresh();
        return html `
      ${this.renderCSS(true)} 
      <div class=${classMap(this.getClassOuterContainer())} @click=${this.handleSelect}>
        <div class=${classMap(this.getClassNav())}>${this.renderNav()}</div>
        <div class="top">${this.renderTop()}</div>
        <div class="bay">${this.curBay === 'All' ? this.renderBaySum() : this.renderBay()}</div>
        <div class=${classMap(this.getClassBottom())}>
            ${this.callMode == 'loading' ? this.renderEquipment() : this.renderShifting()}
        </div>
      </div>
    `;
    }
};
__decorate([
    state()
], PICHatchClerk.prototype, "curBay", void 0);
__decorate([
    query('#selectorOptions')
], PICHatchClerk.prototype, "selectorOptionsGroup", void 0);
__decorate([
    query('#baySelector')
], PICHatchClerk.prototype, "baySelector", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICHatchClerk.prototype, "selectedBay", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICHatchClerk.prototype, "selectedCrane", void 0);
__decorate([
    property({ converter: stringDecoderLC })
], PICHatchClerk.prototype, "callMode", void 0);
__decorate([
    property({ converter: booleanDecoder })
], PICHatchClerk.prototype, "allowPlacement", void 0);
__decorate([
    property({ converter: booleanDecoder })
], PICHatchClerk.prototype, "confirmPlacement", void 0);
__decorate([
    property({ converter: booleanDecoder })
], PICHatchClerk.prototype, "allowUndo", void 0);
__decorate([
    property({ converter: booleanDecoder })
], PICHatchClerk.prototype, "allowShift", void 0);
__decorate([
    property({ converter: booleanDecoder })
], PICHatchClerk.prototype, "confirmShift", void 0);
__decorate([
    property({ converter: booleanDecoder })
], PICHatchClerk.prototype, "autoBayChange", void 0);
__decorate([
    property({ converter: booleanDecoder })
], PICHatchClerk.prototype, "noHdrFooter", void 0);
__decorate([
    property({ converter: booleanDecoder })
], PICHatchClerk.prototype, "lastCellTier", void 0);
__decorate([
    property({ converter: numberDecoder })
], PICHatchClerk.prototype, "bottomRefreshTimer", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICHatchClerk.prototype, "hdrTxt", void 0);
__decorate([
    property({ converter: booleanDecoder })
], PICHatchClerk.prototype, "infoBtn", void 0);
PICHatchClerk = __decorate([
    customElement('pic-hatchclerk')
], PICHatchClerk);
export { PICHatchClerk };
//# sourceMappingURL=PICHatchClerk.js.map